import React, { FunctionComponent } from 'react';
import { DevicePhoneMobileIcon } from '@heroicons/react/20/solid';
import { Tooltip } from 'react-tooltip';
import MarketStateDailyHotelLowestItemSnapshot from '@app/model/market_state/MarketStateDailyHotelLowestItemSnapshot';
import { findProviderData } from '@app/component/provider/FindProviderData';


const RenderProviderWithIndicators: FunctionComponent<{
	lowestItem: MarketStateDailyHotelLowestItemSnapshot
}> = ({ lowestItem }) => {
	return <div className="flex items-center gap-x-2">
		{lowestItem.providers.map(providerPlatform=> {
		return <span className="flex items-center gap-x-2" key={providerPlatform.provider}>
			<a target="_blank" href={providerPlatform.url ?? '#'}>{findProviderData(providerPlatform.provider).icon}</a>
				{(lowestItem.item.filter.hasMemberDiscount || lowestItem.item.filter.hasMobileDiscount) && renderIndicators(lowestItem)}
			<Tooltip id="image-tooltip" />
		</span>})}
	</div>
};


const renderIndicators = (lowestItem: MarketStateDailyHotelLowestItemSnapshot) => {
	return <div className="flex items-center gap-x-1 bg-white rounded py-0.5 px-1 ring-1 ring-black ring-opacity-10">
		{lowestItem.item.filter.hasMemberDiscount && loyaltyIcon}
		{lowestItem.item.filter.hasMobileDiscount && <div className="flex-shrink-0 self-center">{mobileIcon}</div>}
	</div>;
};

const mobileIcon = <><DevicePhoneMobileIcon data-tooltip-id="mobile-tooltip"
																						data-tooltip-content="Special price for mobile"
																						className="w-4 h-4" /><Tooltip id="mobile-tooltip" /></>;
const loyaltyIcon = <><img alt="Loyalty program" data-tooltip-id="loyalty-tooltip"
													 data-tooltip-content="Loyalty program" className="block h-3.5 w-3.5"
													 src={'/assets/img/icons/medal-solid.svg'} /><Tooltip id="loyalty-tooltip" /></>;

export default RenderProviderWithIndicators;